module.exports = __webpack_public_path__ + "vc.svg?0d52b1116574139a04da5c57a6b24b51";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/vc.svg
// module id = 1428
// module chunks = 0